import script from "./world.vue?vue&type=script&setup=true&lang=js"
export * from "./world.vue?vue&type=script&setup=true&lang=js"

import "./world.vue?vue&type=style&index=0&id=25895f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25895f9a"]])

export default __exports__